import { render, staticRenderFns } from "./TableLegend.vue?vue&type=template&id=0ab8bc0a&scoped=true&"
import script from "./TableLegend.vue?vue&type=script&lang=js&"
export * from "./TableLegend.vue?vue&type=script&lang=js&"
import style0 from "./TableLegend.vue?vue&type=style&index=0&id=0ab8bc0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab8bc0a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ab8bc0a')) {
      api.createRecord('0ab8bc0a', component.options)
    } else {
      api.reload('0ab8bc0a', component.options)
    }
    module.hot.accept("./TableLegend.vue?vue&type=template&id=0ab8bc0a&scoped=true&", function () {
      api.rerender('0ab8bc0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TableLegend.vue"
export default component.exports